import { render, staticRenderFns } from "./GroupDevice.vue?vue&type=template&id=70b68294&"
import script from "./GroupDevice.vue?vue&type=script&lang=ts&"
export * from "./GroupDevice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports